import { MediumUnity, type Medium } from '@/models/Medium'
import { EmptyableMediaType } from '@/forms/EmptyTruck'

export const DEFAULT_TRUCK_CAPACITY = 5500 // kg

interface TruckArgs {
  parkCode: string
  wasteWeight: number
  hardDriveNumber: number
  hardDriveWeight: number
  hardDriveM3: number
  hardDriveContainer: number
  dibNumber: number
  dibWeight: number
  electronicalComponentsWeight: number
  electronicalComponentsNumber: number
  electronicalComponentsM3: number
  electronicalComponentsContainer: number
}

export class Truck {
  constructor(args: TruckArgs) {
    return Object.assign(this, args)
  }

  get totalWeight() {
    return (this.wasteWeight || 0) + (this.hardDriveWeight || 0) + (this.dibWeight || 0) + (this.electronicalComponentsWeight || 0)
  }

  get fillingPercentage() {
    return Math.round((this.totalWeight / DEFAULT_TRUCK_CAPACITY) * 100)
  }

  addWeight(media: Medium[]) {
    media.forEach((medium) => {
      const unity = medium.destroyedQuantity.unity
      const quantity = medium.destroyedQuantity.quantity as number

      if (['Papier', 'Papier UC'].includes(medium.label)) {
        this.wasteWeight += quantity
      } else if (['Disque dur', 'Disques durs SSD', 'Disques durs SSD UC'].includes(medium.label)) {
        if (unity === MediumUnity.Unity) {
          this.hardDriveNumber += quantity
        } else if (unity === MediumUnity.Kg) {
          this.hardDriveWeight += quantity
        } else if (unity === 'm3') {
          this.hardDriveM3 += quantity
        } else {
          this.hardDriveContainer += quantity
        }
      } else if (['Composants éléctroniques', 'Composants éléctroniques UC'].includes(medium.label)) {
        if (unity === MediumUnity.Unity) {
          this.electronicalComponentsNumber += quantity
        } else if (unity === MediumUnity.Kg) {
          this.electronicalComponentsWeight += quantity
        } else if (unity === 'm3') {
          this.electronicalComponentsM3 += quantity
        } else {
          this.electronicalComponentsContainer += quantity
        }
      } else {
        if (unity === MediumUnity.Unity) {
          this.dibNumber += quantity
        } else if (unity === MediumUnity.Kg) {
          this.dibWeight += quantity
        }
      }
    })
  }

  resetWeight(mediaType: EmptyableMediaType) {
    if (mediaType === EmptyableMediaType.Paper) {
      this.wasteWeight = 0
    } else if (mediaType === EmptyableMediaType.HardDrive) {
      this.hardDriveNumber = 0
      this.hardDriveWeight = 0
      this.hardDriveM3 = 0
      this.hardDriveContainer = 0
    } else if (mediaType === EmptyableMediaType.ElectronicalComponents) {
      this.electronicalComponentsNumber = 0
      this.electronicalComponentsWeight = 0
      this.electronicalComponentsM3 = 0
      this.electronicalComponentsContainer = 0
    } else {
      this.dibNumber = 0
      this.dibWeight = 0
    }
  }

  static formatWeight(weight: number = 0) {
    return parseFloat((weight / 1000).toFixed(2))
      .toString()
      .replace('.', ',')
  }
}

export interface Truck extends TruckArgs {}
